module.exports = __webpack_public_path__ + "static/media/background.dac187f5.jpg";